import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SchemaOrg from '../../components/feature/SchemaOrg';
import MiniPriceSimulator from '../../components/feature/MiniPriceSimulator';

export default function TransporteurExpressNanterre() {
  useEffect(() => {
    document.title = "Transporteur Express Nanterre (92) | Coursier, Utilitaire avec Chauffeur, Aide Déménagement - Transporteur Express IDF";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Transporteur Express IDF à Nanterre (92) : coursier express, location camion utilitaire avec chauffeur, aide au déménagement, aide au chargement. Intervention 30 min, 24h/7j. Devis gratuit !');
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'transporteur express Nanterre, coursier Nanterre 92, location camion utilitaire avec chauffeur Nanterre, aide au déménagement Nanterre, aide au chargement Nanterre, livraison urgente Nanterre, coursier La Défense, transport express Hauts-de-Seine, déménageur Nanterre, porteur déménagement Nanterre, livraison express 92, utilitaire Nanterre, transport colis Nanterre, coursier professionnel 92');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://transporteurexpressidf.fr/transporteur-express-nanterre');
    }
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', 'Transporteur Express Nanterre (92) | Coursier, Utilitaire avec Chauffeur, Aide Déménagement');
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', 'Transporteur Express IDF à Nanterre (92) : coursier express, location camion utilitaire avec chauffeur, aide au déménagement, aide au chargement. Intervention 30 min, 24h/7j.');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', 'https://transporteurexpressidf.fr/transporteur-express-nanterre');
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', 'Transporteur Express Nanterre (92) | Coursier, Utilitaire avec Chauffeur, Aide Déménagement');
    const twitterDesc = document.querySelector('meta[name="twitter:description"]');
    if (twitterDesc) twitterDesc.setAttribute('content', 'Transporteur Express IDF à Nanterre (92) : coursier express, location camion utilitaire avec chauffeur, aide au déménagement, aide au chargement. Intervention 30 min, 24h/7j.');
    const geoRegion = document.querySelector('meta[name="geo.region"]');
    if (geoRegion) geoRegion.setAttribute('content', 'FR-92');
    const geoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (geoPlacename) geoPlacename.setAttribute('content', 'Nanterre, Hauts-de-Seine');
    const geoPosition = document.querySelector('meta[name="geo.position"]');
    if (geoPosition) geoPosition.setAttribute('content', '48.8924;2.2069');
    const icbm = document.querySelector('meta[name="ICBM"]');
    if (icbm) icbm.setAttribute('content', '48.8924, 2.2069');
    const lastModified = document.querySelector('meta[name="last-modified"]');
    if (lastModified) lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);
  }, []);

  const faqData = [
    {
      question: "Quel est le délai d'intervention à Nanterre ?",
      answer: "Nous intervenons à Nanterre en moins de 30 minutes pour une livraison express. Pour les courses urgentes à La Défense et dans les Hauts-de-Seine (92), notre délai moyen est de 20 à 45 minutes selon votre localisation exacte."
    },
    {
      question: "Livrez-vous à La Défense depuis Nanterre ?",
      answer: "Oui, La Défense est l'une de nos zones prioritaires. Nous livrons quotidiennement dans le quartier d'affaires de La Défense : documents urgents, colis, matériel informatique, etc. Nos coursiers connaissent parfaitement les accès et tours du quartier."
    },
    {
      question: "Proposez-vous un service de coursier régulier pour les entreprises ?",
      answer: "Absolument ! Nous proposons des contrats de coursier régulier pour les entreprises de Nanterre et des Hauts-de-Seine. Tarifs dégressifs selon le volume, facturation mensuelle et suivi dédié pour vos équipes."
    },
    {
      question: "Quels types de marchandises transportez-vous à Nanterre ?",
      answer: "Nous transportons tous types de marchandises : documents et plis urgents, colis jusqu'à 30 kg, matériel informatique, échantillons, fournitures de bureau, petits meubles et équipements. Pour les volumes plus importants, nos utilitaires prennent le relais."
    },
    {
      question: "Êtes-vous disponibles le week-end à Nanterre ?",
      answer: "Oui, notre service est disponible 7j/7 et 24h/24 à Nanterre et dans tout le 92. Que ce soit un samedi matin ou un dimanche soir, nous assurons vos livraisons urgentes sans supplément de nuit."
    }
  ];

  return (
    <>
      <SchemaOrg
        type="LocalBusiness"
        name="Transporteur Express - Nanterre"
        description="Coursier express et livraison urgente à Nanterre et dans les Hauts-de-Seine (92)"
        areaServed="Nanterre, La Défense, Hauts-de-Seine, Île-de-France"
      />

      <Navbar />
      <WhatsAppButton />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-50 via-white to-gray-50 pt-24 pb-16 lg:pt-32 lg:pb-24 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-5"
          style={{ backgroundImage: "url('https://public.readdy.ai/ai/img_res/ac78cf05817d45218e6031f28344151d.jpg')" }}
        ></div>

        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-map-pin-line"></i>
              <span>Nanterre (92) — Hauts-de-Seine</span>
            </div>

            <h1 className="text-4xl lg:text-6xl font-extrabold text-gray-900 mb-6 leading-tight">
              Transporteur Express à <span className="text-red-600">Nanterre (92)</span> — Coursier &amp; Livraison Urgente
            </h1>

            <p className="text-lg lg:text-xl text-gray-700 mb-8 leading-relaxed max-w-3xl mx-auto">
              Vous cherchez un <strong>coursier express fiable à Nanterre</strong> ? Nous intervenons en moins de 30 minutes pour vos <strong>livraisons urgentes de colis et documents</strong> dans tout le <strong>92 — Hauts-de-Seine</strong>. Entreprises de La Défense, particuliers, profitez d'un service clé en main avec <strong>utilitaire avec chauffeur</strong> disponible 24h/24 et 7j/7.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="sms:+33632410246?body=Bonjour,%20je%20souhaite%20obtenir%20un%20devis%20gratuit%20pour%20une%20livraison%20express%20à%20Nanterre.%20Merci%20de%20me%20recontacter%20avec%20les%20détails%20et%20tarifs.%20Cordialement."
                className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600 to-red-700 text-white px-8 py-4 rounded-full font-bold text-lg hover:from-red-700 hover:to-red-800 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-message-3-line text-xl"></i>
                Devis gratuit
              </a>
              <a
                href="tel:+33632410246"
                className="inline-flex items-center gap-2 bg-white text-gray-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-50 transition-all shadow-lg border-2 border-gray-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                06 32 41 02 46
              </a>
            </div>
          </div>

          {/* Mini Price Simulator */}
          <div className="max-w-4xl mx-auto">
            <MiniPriceSimulator />
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-3xl lg:text-5xl font-extrabold text-gray-900 mb-4">
              Nos Services de Transport Express à Nanterre
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Solutions rapides et fiables pour les professionnels et particuliers de Nanterre et des Hauts-de-Seine
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            <div className="bg-gradient-to-br from-red-50 to-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-red-100">
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-2xl flex items-center justify-center mb-6 shadow-md">
                <i className="ri-e-bike-2-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Coursier Moto Express</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Livraison ultra-rapide de plis, documents et petits colis à Nanterre et La Défense en moins de 30 min.
              </p>
              <div className="text-red-600 font-bold text-lg">Dès 9,90€</div>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-blue-100">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mb-6 shadow-md">
                <i className="ri-truck-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Utilitaire avec Chauffeur</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Transport de volumes importants, mobilier, équipements professionnels dans tout le 92.
              </p>
              <div className="text-blue-600 font-bold text-lg">Dès 19,90€</div>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-green-100">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-2xl flex items-center justify-center mb-6 shadow-md">
                <i className="ri-file-text-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Livraison Documents</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Coursier dédié pour vos documents urgents, contrats, actes notariés et plis confidentiels.
              </p>
              <div className="text-green-600 font-bold text-lg">Dès 9,90€</div>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-orange-100">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl flex items-center justify-center mb-6 shadow-md">
                <i className="ri-repeat-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Tournées Régulières B2B</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Contrats de livraisons récurrentes pour les entreprises du 92 avec tarifs dégressifs.
              </p>
              <div className="text-orange-600 font-bold text-lg">Tarifs préférentiels</div>
            </div>
          </div>
        </div>
      </section>

      {/* Zones Section */}
      <section className="py-16 lg:py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-3xl lg:text-5xl font-extrabold text-gray-900 mb-4">
              Zones Couvertes depuis Nanterre
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Nous couvrons tout le 92 et l'Île-de-France pour vos livraisons express
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { name: 'Nanterre', dept: '92', icon: 'ri-building-4-line', desc: 'Centre-ville, université, zones industrielles' },
              { name: 'La Défense', dept: '92', icon: 'ri-building-line', desc: 'Quartier d\'affaires, tours, CNIT' },
              { name: 'Rueil-Malmaison', dept: '92', icon: 'ri-map-pin-line', desc: 'Zones d\'activités, entreprises' },
              { name: 'Courbevoie', dept: '92', icon: 'ri-store-line', desc: 'Commerces, bureaux, résidentiel' },
              { name: 'Puteaux', dept: '92', icon: 'ri-government-line', desc: 'Île de la Jatte, zones logistiques' },
              { name: 'Toute l\'Île-de-France', dept: '75-95', icon: 'ri-road-map-line', desc: 'Livraison express régionale' }
            ].map((zone, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border border-gray-100">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${zone.icon} text-xl text-white`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">
                      {zone.name} <span className="text-red-600">({zone.dept})</span>
                    </h3>
                    <p className="text-sm text-gray-600">{zone.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-3xl lg:text-5xl font-extrabold text-gray-900 mb-4">
              Pourquoi nous choisir à Nanterre ?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <i className="ri-flashlight-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Intervention en 30 min</h3>
              <p className="text-gray-600">
                Nos coursiers sont positionnés à Nanterre et La Défense pour une réactivité maximale
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <i className="ri-time-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Disponible 24h/24 — 7j/7</h3>
              <p className="text-gray-600">
                Nuits, week-ends et jours fériés : nous assurons vos livraisons sans interruption
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <i className="ri-shield-check-line text-4xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Livraisons Sécurisées</h3>
              <p className="text-gray-600">
                Tous nos transports sont assurés. Vos marchandises sont entre de bonnes mains
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 lg:py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-3xl lg:text-5xl font-extrabold text-gray-900 mb-4">
              Questions Fréquentes
            </h2>
            <p className="text-lg text-gray-600">
              Tout ce que vous devez savoir sur notre service de transport express à Nanterre
            </p>
          </div>

          <div className="space-y-4">
            {faqData.map((faq, index) => (
              <details key={index} className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden group">
                <summary className="px-6 py-5 cursor-pointer list-none flex items-center justify-between font-bold text-gray-900 hover:bg-gray-50 transition-colors">
                  <span className="text-base lg:text-lg">{faq.question}</span>
                  <i className="ri-arrow-down-s-line text-2xl text-red-600 group-open:rotate-180 transition-transform flex-shrink-0 ml-4"></i>
                </summary>
                <div className="px-6 pb-5 pt-2 text-gray-600 leading-relaxed border-t border-gray-100">
                  {faq.answer}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 lg:py-24 bg-gradient-to-br from-red-600 to-red-700 text-white relative overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-10"
          style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=delivery-courier-motorcycle-speeding-through-city-streets-motion-blur-urban-express-transport-professional-service-dynamic-composition&width=1920&height=600&seq=nanterre-cta-bg&orientation=landscape')" }}
        ></div>

        <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
          <h2 className="text-3xl lg:text-5xl font-extrabold mb-6">
            Besoin d'un coursier express à Nanterre ?
          </h2>
          <p className="text-xl lg:text-2xl mb-10 text-red-50">
            Contactez-nous maintenant pour un devis gratuit et une intervention rapide
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="sms:+33632410246?body=Bonjour,%20je%20souhaite%20obtenir%20un%20devis%20gratuit%20pour%20une%20livraison%20express%20à%20Nanterre.%20Merci%20de%20me%20recontacter%20avec%20les%20détails%20et%20tarifs.%20Cordialement."
              className="inline-flex items-center gap-2 bg-white text-red-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-message-3-line text-xl"></i>
              Demander un devis
            </a>
            <a
              href="tel:+33632410246"
              className="inline-flex items-center gap-2 bg-red-800 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-red-900 transition-all shadow-xl border-2 border-white/20 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              06 32 41 02 46
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
